import Model from 'models/Model';

export default class ClaimJobReport
  extends Model<Model.IClaimJobReport>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IClaimJobReport>
{
  id: number;
  productReport: object;
  claimJobId: number;
  claimTypeReportSettingId: number;

  constructor(
    data: Partial<Model.IClaimJobReport> | Utils.FormData<Model.IClaimJobReport>,
    language?: Locale.Languages
  ) {
    super({}, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id.toString(),
    };
  }
}
